
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.25 22a.75.75 0 01-.658-.391l-.021-.038A12.754 12.754 0 0011.418 15H10v4.25a.75.75 0 01-1.272.538l-8.5-8.25a.747.747 0 010-1.076l8.5-8.25A.75.75 0 0110 2.75v4.252c7.743.134 14 6.474 14 14.248a.75.75 0 01-.75.75zm-14-8.5h2.168c4.176 0 8.089 1.829 10.764 4.911C20.888 12.742 15.805 8.5 9.75 8.5h-.5a.75.75 0 01-.75-.75V4.523L1.827 11 8.5 17.477V14.25a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    